// extracted by mini-css-extract-plugin
export default {"button":"Xl-z","reviewSort":"Yl-z"};